/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SchedulerSessionJobData
 */
export interface SchedulerSessionJobData {
    /**
     * 
     * @type {string}
     * @memberof SchedulerSessionJobData
     */
    integrationId?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerSessionJobData
     */
    integrationName?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerSessionJobData
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof SchedulerSessionJobData
     */
    failureMessage?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SchedulerSessionJobData
     */
    startedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SchedulerSessionJobData
     */
    finishedAt?: Date | null;
}

/**
 * Check if a given object implements the SchedulerSessionJobData interface.
 */
export function instanceOfSchedulerSessionJobData(value: object): value is SchedulerSessionJobData {
    return true;
}

export function SchedulerSessionJobDataFromJSON(json: any): SchedulerSessionJobData {
    return SchedulerSessionJobDataFromJSONTyped(json, false);
}

export function SchedulerSessionJobDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SchedulerSessionJobData {
    if (json == null) {
        return json;
    }
    return {
        
        'integrationId': json['integrationId'] == null ? undefined : json['integrationId'],
        'integrationName': json['integrationName'] == null ? undefined : json['integrationName'],
        'status': json['status'] == null ? undefined : json['status'],
        'failureMessage': json['failureMessage'] == null ? undefined : json['failureMessage'],
        'startedAt': json['startedAt'] == null ? undefined : (new Date(json['startedAt'])),
        'finishedAt': json['finishedAt'] == null ? undefined : (new Date(json['finishedAt'])),
    };
}

export function SchedulerSessionJobDataToJSON(json: any): SchedulerSessionJobData {
    return SchedulerSessionJobDataToJSONTyped(json, false);
}

export function SchedulerSessionJobDataToJSONTyped(value?: SchedulerSessionJobData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'integrationId': value['integrationId'],
        'integrationName': value['integrationName'],
        'status': value['status'],
        'failureMessage': value['failureMessage'],
        'startedAt': value['startedAt'] == null ? value['startedAt'] : value['startedAt'].toISOString(),
        'finishedAt': value['finishedAt'] == null ? value['finishedAt'] : value['finishedAt'].toISOString(),
    };
}

